/**
 * PageSizeControl (X-6.3) — rows per page, persisted per table.
 *
 * Lives in the list TOOLBAR beside Columns and Table/Cards, not inside the
 * Pager: the Pager hides itself when everything fits on one page, so a size
 * control inside it would become unreachable at exactly the moment somebody
 * wanted to lower the size and get their pager back.
 *
 * A native <select> and not a popover. Three fixed numbers is what selects are
 * for, it is keyboard- and screen-reader-correct with no work, and it matches
 * the other compact toolbar controls in height.
 */

import { PAGE_SIZES, type PageSize } from '@propos/shared';
import type { ReactNode } from 'react';

export function PageSizeControl({
  pageSize,
  onChange,
}: {
  readonly pageSize: PageSize;
  readonly onChange: (next: PageSize) => void;
}): ReactNode {
  return (
    <label className="inline-flex shrink-0 items-center gap-1.5 text-meta text-ink2">
      Show
      <select
        value={pageSize}
        onChange={(event) => {
          onChange(Number(event.target.value) as PageSize);
        }}
        // keeper-ignore: a display preference, not a credential field (ADR-40).
        data-keeper-ignore
        className="min-h-9 rounded-ctl border border-control-line bg-card px-2 text-meta font-medium text-ink focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-brand-700"
      >
        {PAGE_SIZES.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
      per page
    </label>
  );
}
